import httpClient from "@/services";
import { API_ENDPOINTS } from "@/services/endpoints";
import type { TaxFormFetchRequest } from "@/model/taxForm";

export const fetchTaxForm = async (fetchReqData: TaxFormFetchRequest) => {
  const url = API_ENDPOINTS.TAX_FORM.FETCH;
  const config = {
    headers: {
      Authorization: `Bearer ${fetchReqData?.accessToken}`,
    },
    body: {
      memberId: fetchReqData?.memberId,
      groupId: fetchReqData?.groupId,
      employeeId: fetchReqData?.employeeId,
      documentType: fetchReqData?.documentType,
    },
  };
  return httpClient
    .post(url, { ...config.body }, { headers: config.headers })
    .then((res) => res?.data);
};
